// The answer streaming right now, by thread and resumable stream id (BUILD 2
// C2-6): read-aloud speaks a live answer through the `/speak` source
// `{kind:'message', threadId, messageId, streamId}` while it streams, which
// first audio within a second (METRIC-081) needs. app.tsx publishes the stream
// id its resumable transport persists for the thread's turn; VoiceRoot and the
// player read it. Written by WP2-0b; frozen after the b2-contracts tag.
import type { ResumableClientStorage } from '@assistant-ui/react-ai-sdk';

export type LiveAnswer = { threadId: string; streamId: string };

let current: LiveAnswer | null = null;
const listeners = new Set<() => void>();

function publish(next: LiveAnswer | null) {
  current = next;
  for (const listener of [...listeners]) listener();
}

export const liveAnswer = {
  current: (): LiveAnswer | null => current,
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

/**
 * The thread's resume storage, publishing the stream id it persists as the
 * live answer and withdrawing it when the thread's stream is cleared.
 */
export function publishingResumeStorage(
  storage: ResumableClientStorage,
  threadId: string,
): ResumableClientStorage {
  return {
    getStreamId: () => storage.getStreamId(),
    setStreamId: (streamId) => {
      storage.setStreamId(streamId);
      publish({ threadId, streamId });
    },
    clear: () => {
      storage.clear();
      if (current?.threadId === threadId) publish(null);
    },
  };
}
